import React from 'react';
import { inject, observer } from 'mobx-react';
import { Spin } from 'antd';
import { WeaPopoverHrm } from 'ecCom';
import { WeaMessageCenter } from 'comsMobx';
const WeaMessageCenterStore = WeaMessageCenter.store;
import { WeaPortalLayout } from 'weaPortalPublic';
import { getSearchParams } from '../../util/loginUtil';

import E8Theme from './ecology8/';
import E9Theme from './ecology9/';
import E9ThemeLayout2 from './ecology9/layout2/';
import E9ThemeLayout3 from './ecology9/layout3/';
import E9ThemeLayout4 from './ecology9/layout4/';
import E9ThemeLayout5 from './ecology9/layout5/';

@inject('portalThemeStore')
@observer
class Theme extends React.Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    const { portalThemeStore, location = {} } = this.props;
    const { query = {} } = location;
    const params = { ...getSearchParams(window.location.search), ...query };
    portalThemeStore.getThemeInfo(params);
    portalThemeStore.getThemeConfig();
    portalThemeStore.getFrontEndMenu();
  }

  componentDidMount() {
    const { portalThemeStore } = this.props;
    portalThemeStore.doAfterThemeRenderEvent();
  }

  componentWillUnmount() {
    const { portalThemeStore } = this.props;
    portalThemeStore.removePlugins();
  }

  render() {
    const { portalThemeStore } = this.props;
    const { loading, pluginLoading, themeInfo, customLoading } = portalThemeStore;
    const { themeType, themeLayoutType, layoutData = {} } = themeInfo;

    if (loading) {
      return (
        <Spin
          spinning={true}
          size="large"
          style={{
            position: 'absolute',
            top: '50%',
            width: '100%',
            height: '32px',
            marginTop: '-16px',
            textAlign: 'center'
          }}
        />
      );
    }

    let themeComp = <div />;
    if (themeType == 'ecology8') {
      themeComp = <E8Theme {...this.props} />;
    } else if (themeType == 'ecology9') {
      if (themeLayoutType == '1') {
        themeComp = <E9Theme {...this.props} />;
      } else if (themeLayoutType == '2') {
        themeComp = <E9ThemeLayout2 {...this.props} />;
      } else if (themeLayoutType == '3') {
        themeComp = <E9ThemeLayout3 {...this.props} />;
      } else if (themeLayoutType == '4') {
        themeComp = <E9ThemeLayout4 {...this.props} />;
      } else if (themeLayoutType == '5') {
        themeComp = <E9ThemeLayout5 {...this.props} />;
      } else {
        themeComp = <E9Theme {...this.props} />;
      }
    } else if (themeType == 'ECustom') {
      const { layoutId, layoutType, layoutCustom, layoutConfig = {}, layoutUUID } = layoutData;
      if (layoutCustom == '1') {
        if (customLoading && window[layoutConfig.module]) {
          const ECustomTheme = window[layoutConfig.module]['com'][layoutConfig.component];
          themeComp = <ECustomTheme {...this.props} />;
        } else {
          if (window.rewritePortalTheme && typeof window.rewritePortalTheme == 'function') {
            themeComp = window.rewritePortalTheme({ ...this.props }, { id: layoutUUID });
          }
        }
      } else {
        themeComp = <WeaPortalLayout id={layoutId} layoutId={layoutId} layoutType={layoutType} {...this.props} />;
      }
    } else {
      themeComp = <E9Theme {...this.props} />;
    }

    return (
      <div style={{ width: '100%', height: '100%', overflow: 'auto' }}>
        <WeaPopoverHrm />
        {!pluginLoading && <WeaMessageCenter.FixedPop systemSetStore={WeaMessageCenterStore} />}
        {themeComp}
      </div>
    );
  }
}

export default Theme;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/theme/index.js